import React, { useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import API from "api.js";

const VideoPopup = ({videoPopup,setVideoPopup,videoData,dataLoaded,setDataLoaded}) => {

const [loading, setLoading] = React.useState(true);
// const frameLoad = () => {
//     setDataLoaded((prevState) => !prevState);
//   };

  const getEmbedUrl = (url) => {
  return url.replace("watch?v=", "embed/");
};

 const markAsView = (e) => {
    e.preventDefault();
    let bodyFormData = new FormData();
    bodyFormData.set("vid", videoData?.id);
    API({
      method: "POST",
      url: "mark/viewed",
      data: bodyFormData,
    });
    setVideoPopup(false);
  };

  return (
              <Modal
                show={videoPopup}
                size="lg"
                modalClassName="dashboard-video-popup"
                className="modal-dialog-centered"
              >
                <div className="modal-header d-flex justify-content-between">
                  <h5 className="modal-title FS16FW500">New tips and strategies</h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={(e) => markAsView(e)}
                  ></button>
                </div>
                <Modal.Body className="d-flex align-items-center justify-content-center flex-column">
                  <iframe
                    className="dashboard-popup-video"
                    src={getEmbedUrl(videoData?.video_url)}
                    title="YouTube Live video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    frameBorder="0"
                //     onLoad={frameLoad}
                     style={{   
                     width: "clamp(258px, 60vw, 610px)",  
                     height: "clamp(120px, 35vw, 330px)",
                  }}
                  ></iframe>
                  {/* {!loading && <div className="text-center">Loading...</div>} */}
                </Modal.Body>
              </Modal>
  )
}

export default VideoPopup
